import { Field } from 'module/api/field/types';
import { useDeleteFieldMutation, useUpdateFieldMutation } from 'queries/fields';
import { FC, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { FieldListWrapper, HeaderRow, HeaderRowItem } from './components';
import { FieldRow } from './field-row';

interface Props {
  fields: Field[];
  onEdit: (field: Field) => void;
}
export const SignalFieldsList: FC<Props> = ({ fields, onEdit }) => {
  const {
    mutateAsync: updateFieldApi,
    variables: updatingField,
    isPending: isUpdatingField,
  } = useUpdateFieldMutation();
  const {
    mutateAsync: deleteFieldApi,
    variables: deletingField,
    isPending: isDeletingField,
  } = useDeleteFieldMutation();
  const changeFieldEnabledStatus = useCallback(
    (field: Field, nextStatus: boolean) => {
      return updateFieldApi({
        ...field,
        fieldId: field.fieldId,
        payload: { isEnabled: nextStatus },
      })
        .then((response) => {
          return response;
        })
        .catch(() => {
          return field;
        });
    },
    [updateFieldApi],
  );
  const deleteField = useCallback(
    (field: Field) => {
      return deleteFieldApi(field)
        .then(() => {})
        .catch(() => {});
    },
    [deleteFieldApi],
  );

  return (
    <FieldListWrapper>
      <HeaderRow>
        <HeaderRowItem>
          <FormattedMessage id="name" />
        </HeaderRowItem>
        <HeaderRowItem>
          <FormattedMessage id="description" />
        </HeaderRowItem>
        <HeaderRowItem>
          <FormattedMessage id="type" />
        </HeaderRowItem>
        <HeaderRowItem>
          <FormattedMessage id="Status" />
        </HeaderRowItem>
        <HeaderRowItem />
      </HeaderRow>
      {fields.map((field) => (
        <FieldRow
          key={field.fieldId}
          field={field}
          loading={
            (isUpdatingField && updatingField?.fieldId === field.fieldId) ||
            (isDeletingField && deletingField?.fieldId === field.fieldId)
          }
          changeEnabledStatus={(status) =>
            changeFieldEnabledStatus(field, status)
          }
          onDelete={() => deleteField(field)}
          onEdit={() => onEdit(field)}
        />
      ))}
    </FieldListWrapper>
  );
};
